import apiClient from '@/services/axios'

export const getResellerList = async ({ commit, rootState }, payload) => {
  try {
    commit('SET_LOADING_RESELLER', true)
    const { data: response } = await apiClient.get(`/admin/resellers/${rootState.app.id}`, {
      params: {
        ...payload,
      },
    })
    commit('SET_RESELLER_LIST', response.data)
    return Promise.resolve(response)
  } catch (err) {
    return Promise.reject(err)
  } finally {
    commit('SET_LOADING_RESELLER', false)
  }
}

export const getResellerDetail = async ({ commit, rootState }, { seller_hashid }) => {
  try {
    const { data: response } = await apiClient({
      method: 'get',
      url: `/users/private/seller/${seller_hashid}`,
    })
    return Promise.resolve(response)
  } catch (error) {
    return Promise.reject(error)
  }
}
